import React, { createContext, useContext, useState, useCallback } from 'react';
import { az, en } from '../i18n/translations';

const LanguageContext = createContext();

const LANGS = { az, en };

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'az');

  const switchLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem('lang', l);
  }, []);

  const t = useCallback((key, fallback) => {
    const keys = key.split('.');
    let val = LANGS[lang];
    for (const k of keys) {
      if (!val) return fallback || key;
      val = val[k];
    }
    return val || LANGS.az[keys[keys.length - 1]] || fallback || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
